import { useTranslation } from 'react-i18next';
import { Badge, BadgeVariant } from 'components/Badge';
import { ScreenerAreaGrade } from 'domains/signup/screener/data/results';
import { IconNameType } from 'components/Icon';

type Props = {
  grade: ScreenerAreaGrade;
  className?: string;
};

const COLOR_MAP: Record<ScreenerAreaGrade, BadgeVariant> = {
  'on-track': 'green',
  'support-needed': 'yellow',
};

const ICON_MAP: Record<ScreenerAreaGrade, IconNameType> = {
  'on-track': 'CheckCircle',
  'support-needed': 'Warning',
};

export const ScreenerGradeBadge: React.FC<Props> = ({ grade, className }) => {
  const { t } = useTranslation();

  return (
    <Badge icon={ICON_MAP[grade]} variant={COLOR_MAP[grade]} className={className}>
      {t(`screener.results.progress.${grade}`)}
    </Badge>
  );
};
